import "../styles/About.css";

function About() {
  return (
    <main className="about">

      {/* Εισαγωγή */}
      <section className="about-intro">
        <div className="about-intro-inner">
          <h1>ΚΑΡΤΕΡΙΑ ΣΥΜΒΟΥΛΕΥΤΙΚΗ Ε.Ε.</h1>
          <p>
            Η ΚΑΡΤΕΡΙΑ ΣΥΜΒΟΥΛΕΥΤΙΚΗ Ε.Ε. δραστηριοποιείται στον χώρο των κατασκευών και της
            συμβουλευτικής, προσφέροντας ολοκληρωμένες λύσεις σε ιδιώτες και επιχειρήσεις.
          </p>
          <div className="about-intro-body">
            <p>Δραστηριοποιούμαστε στον χώρο των κατασκευών και της συμβουλευτικής, προσφέροντας ολοκληρωμένες λύσεις σε ιδιώτες και επιχειρήσεις. Αναλαμβάνουμε έργα από τη μελέτη και τον σχεδιασμό έως την πλήρη κατασκευή και διαχείριση.</p>
            <p>Η ομάδα μας αποτελείται από μηχανικούς, τεχνικούς και συμβούλους με πολυετή εμπειρία, οι οποίοι εργάζονται με γνώμονα την ποιότητα, τη συνέπεια και τη βιωσιμότητα — συνδυάζοντας τεχνική γνώση με καινοτόμο σκέψη.</p>
          </div>
        </div>
      </section>

      {/* Όραμα */}
      <section className="about-vision">
        <h2>Το όραμά μας</h2>
        <p>
          Να δημιουργούμε έργα που βελτιώνουν την καθημερινότητα, σέβονται το περιβάλλον
          και ανταποκρίνονται στις ανάγκες κάθε πελάτη με επαγγελματισμό και υπευθυνότητα.
        </p>
      </section>

      {/* Τομείς δραστηριότητας */}
      <section className="about-bottom">
        <div className="about-grid">

          <div className="about-card">
            <h3>Ανέγερση & Αξιοποίηση Ακινήτων</h3>
            <p>
              Η ΚΑΡΤΕΡΙΑ Κατασκευαστική & Συμβουλευτική δραστηριοποιείται στην ανέγερση και
              αξιοποίηση ακινήτων, παρέχοντας ολοκληρωμένες υπηρεσίες τεχνικής, οργανωτικής
              και λειτουργικής υποστήριξης σε όλα τα στάδια ανάπτυξης ενός ακινήτου.
            </p>
            <p>
              Η προσέγγισή μας καλύπτει ολόκληρο τον κύκλο ζωής του έργου, από τη σύλληψη
              και την ωρίμανση της επένδυσης έως την κατασκευή, την παράδοση και τη λειτουργική
              αξιοποίηση του ακινήτου. Κάθε έργο αντιμετωπίζεται με γνώμονα τη βιωσιμότητα,
              τη λειτουργικότητα και τη μακροχρόνια διατήρηση της αξίας του.
            </p>
          </div>

          <div className="about-card">
            <h3>Βιωσιμότητα & Περιβαλλοντικός Σχεδιασμός</h3>
            <p>
              Η ΚΑΡΤΕΡΙΑ Κατασκευαστική & Συμβουλευτική παρέχει εξειδικευμένες υπηρεσίες
              βιωσιμότητας, περιβαλλοντικού σχεδιασμού και πιστοποιήσεων έργων, με στόχο
              την ανάπτυξη τεχνικών έργων που ανταποκρίνονται στις σύγχρονες απαιτήσεις
              ενεργειακής αποδοτικότητας, περιβαλλοντικής ευθύνης και ποιότητας.
            </p>
            <p>
              Η προσέγγισή μας ενσωματώνει τη βιωσιμότητα και τον ενεργειακό σχεδιασμό
              από τα πρώτα στάδια του έργου, συμβάλλοντας στη δημιουργία αποδοτικών,
              λειτουργικών και περιβαλλοντικά υπεύθυνων κατασκευών με αυξημένη αξία.
            </p>
          </div>

          <div className="about-card">
            <h3>Διοίκηση & Διαχείριση Έργων</h3>
            <p>
              Η ΚΑΡΤΕΡΙΑ Κατασκευαστική & Συμβουλευτική παρέχει ολοκληρωμένες υπηρεσίες
              διοίκησης και διαχείρισης τεχνικών έργων, καλύπτοντας το σύνολο των
              διαδικασιών Project & Construction Management σε όλα τα στάδια του κύκλου
              ζωής του έργου.
            </p>
            <p>
              Η διοίκηση του έργου αντιμετωπίζεται ως ενιαία και ολοκληρωμένη διαδικασία,
              η οποία περιλαμβάνει τον σχεδιασμό, τον έλεγχο και την παρακολούθηση της
              κατασκευής, τη διαχείριση χρόνου και κόστους, καθώς και τη θεσμικά
              τεκμηριωμένη λήψη αποφάσεων.
            </p>
          </div>

          <div className="about-card">
            <h3>Εκπόνηση & Διοίκηση Μελετών</h3>
            <p>
              Η ΚΑΡΤΕΡΙΑ Κατασκευαστική & Συμβουλευτική παρέχει υπηρεσίες εκπόνησης,
              διοίκησης και τεχνικού ελέγχου μελετών για τεχνικά έργα, με στόχο τη θεσμικά
              ορθή ωρίμανση, την τεχνική πληρότητα και τη δυνατότητα άμεσης και ασφαλούς
              υλοποίησης.
            </p>
            <p>
              Η μελετητική διαδικασία αντιμετωπίζεται ως καθοριστικό στάδιο του έργου,
              στο οποίο τεκμηριώνεται η σκοπιμότητα, διασφαλίζεται η κανονιστική
              συμμόρφωση και δημιουργούνται οι προϋποθέσεις για ομαλή αδειοδότηση,
              χρηματοδότηση και κατασκευή.
            </p>
          </div>

        </div>
      </section>

    </main>
  );
}

export default About;